// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1WE2F","list":"PatternAutocomplete_list__3DSJ7"};